export const Contracts: any = {
  NEW: "new",
  EXISTING: "existing",
};

export default Contracts;
